import { PropertyTypes } from "epsm-api-types";
import {
	DEFAULT_DATE_OPTIONS,
	formatValue,
	formatValueDate,
	formatValueTime,
} from "@/components/widgets/helpers/FormattingHelpers";

const SHORT_DATE_OPTIONS: Intl.DateTimeFormatOptions = {
	...DEFAULT_DATE_OPTIONS,
	year: undefined,
};

export function formatDateRelativeToToday(date: Date): string | null {
	const now = new Date();
	const isToday = date.toDateString() === now.toDateString();
	const isCurrentYear = date.getFullYear() === now.getFullYear();

	return isToday
		? formatValueTime(date).toLocaleLowerCase()
		: isCurrentYear
			? formatValue(date, PropertyTypes.DATE, SHORT_DATE_OPTIONS, "")
			: formatValueDate(date);
}
